import React from 'react';
import useLocationQuery from '../../hooks/useQuery';
import { LIVE_DASHBOARD } from './constants';
import LiveDashboardPage from './LiveDashboardPage';
import LiveReportsPage from './LiveReportsPage';


const DashboardPage = () => {
  const { query } = useLocationQuery();

  return (
    <>
      {[LIVE_DASHBOARD, undefined].includes(query.tab) ? (
        <LiveDashboardPage />
      ) : (
        <LiveReportsPage />
      )}
    </>
  );
};

export default DashboardPage;
